<template>
  <div>
    <div class="py-4 container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="card" style="height: 655px">
            <div class="card-header py-3">
              <div class="d-lg-flex align-items-center row">
                <div class="col-2">
                  <h5 class="mb-0">Menu</h5>
                </div>
                <div class="col-8">
                  <input v-model="table.search" class="form-control rounded-pill text-center" type="text" placeholder="Search Menu" @keyup="filter"/>
                </div>
              </div>
            </div>
            <div class="table-responsive" style="height: 500px">
              <table v-if="!table.onLoad" class="table">
                <thead class="table-primary">
                  <tr>
                    <th class="text-uppercase text-dark text-xxs font-weight-bolder">
                      Menu Name
                    </th>
                    <th class="text-uppercase text-dark text-xxs font-weight-bolder">
                      Status
                    </th>
                    <th class="text-uppercase text-dark text-xxs font-weight-bolder">
                      Created At
                    </th>
                  </tr>
                </thead>
                <tbody v-if="table.data.length > 0">
                  <tr v-for="menu in table.data" :key="menu.id">
                    <td class="text-sm py-3 px-4">{{ menu.name }}</td>
                    <td class="text-sm py-3 px-4">
                      <div>
                        <ArgonSwitch
                          :id="menu.name"
                          :name="menu.name"
                          :checked="menu.status === 'active'"
                          @change="updateStatus(menu)"
                        />
                      </div>
                    </td>
                    <td class="text-sm py-3 px-4">{{ formatDate(menu.created_at) }}</td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr class="text-center">
                    <td colspan="4">No Data</td>
                  </tr>
                </tbody>
              </table>
              <SkeletonLoading
                  v-else
                  class="px-4 pt-5"
                  :shapes="[
                    { type: 'line', width: '100%', height: '20px' },
                    { type: 'line', width: '80%', height: '20px' },
                    { type: 'line', width: '60%', height: '20px' },
                  ]"
                />
            </div>

            <div class="card-footer pb-0">
              <span class="float-start">
                <BasePagination v-model="table.page.current_pages" :page-count="table.page.total_pages" size="sm" @click="changePage()"/>
              </span>
              <span class="float-end">
                {{ ((table.page.current_pages - 1) * table.page.per_pages) + table.data.length }} of {{ table.total }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BasePagination from "@/components/BasePagination.vue";
import SkeletonLoading from "@/components/SkeletonLoading.vue";
import api from "@/helpers/api";
import menuService from "@/services/generalSettings/menuService";
import ArgonSwitch from "@/components/ArgonSwitch.vue";
import moment from "moment";
import { mapActions } from "vuex";
moment.locale("id");

export default {
  components: {
    BasePagination,
    SkeletonLoading,
    ArgonSwitch,
  },
  data() {
    return {
      loadTimeout: null,
      table: {
        onLoad: false,
        search: this.$route.query.search ? this.$route.query.search : '',                    
        data: [],
        page: {
          current_pages: 1,
        },
      },
    };
  },
  computed: {
  },
  mounted() {
    this.get();
  },
  methods: {
    ...mapActions("auth", ["updateStatMenuOrSubMenu"]),
    async updateStatus(menu) {
      this.table.onLoad = true;
      const newStatus = menu.status === "active" ? "inactive" : "active";
      const payload = {
        name: menu.name,
        status: newStatus,
        sub_menu: menu.sub_menu,
      };
      try {
        await api(this, menuService.updateManageMenuStatus("manage-menu", [payload]));
        menu.status = newStatus;
        this.updateStatMenuOrSubMenu({ type: "menu", value: menu.name });
      } catch (error) {
        if (error.response?.data?.code == 400) {
          error.response.data.data.forEach((v) => {
            this.modal.errorMessage[v.path] = v.msg;
          });
        }
      } finally {
        this.table.onLoad = false;
      }
    },
    filter() {
      if (this.table.search != this.$route.query.search) {
      clearTimeout(this.table.loadTimeout);
      this.table.loadTimeout = setTimeout(() => {
        if (this.table.search == "") {
          this.$router.push({ name: 'Menu', params: { moduleSlug: 'material-management' }, query: null });
        }else{
          this.$router.push({ name: 'Menu', params: { moduleSlug: 'material-management' }, query: { search: this.table.search } });
        }
          this.get();
      }, 500);
    }
    },

    async get() {
      this.table.onLoad = true;

      try {
        const response = await api(this, menuService.getManageMenu(this.table.page.current_pages, {search: this.table.search}), false);
        
        this.table.data  = response.data;  
        this.table.total = response.total_items;
        this.table.page  = response;  

      } catch (error) {
        this.table.data  = [];     
        this.table.total = 0;
      } finally {
        this.table.onLoad = false;
      } 
    },

    formatDate(date) {
      return moment(date).format("DD MMMM YYYY, HH:mm");
    },

    onPageChanged(page) {
      this.current_pages = page;
    },
  },
};
</script>